import { useSubscription } from '../../../hooks/useSubscription';
import { addAlert } from '../../../utils/alerts';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useNotificationsQuery } from '../hooks/useNotificationsQuery';
import { SubscriptionsAdminHost } from '../../../components/SubscriptionsAdminHost';
import { jsx as _jsx } from "react/jsx-runtime";
export function EditModal({
  actions,
  refetchStaleData
}) {
  const {
    isOpen,
    close
  } = actions;
  const subscription = useSubscription();
  const {
    sendEmailForSubscriptionChanged
  } = useNotificationsQuery();
  const onClose = closedPayload => {
    refetchStaleData();
    if ('didUpdateSubscription' in closedPayload && closedPayload.didUpdateSubscription) {
      addAlert({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.EditModal.successfullyChangedTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: sendEmailForSubscriptionChanged ? 'subscriptions.EditModal.successfullyChangedMessageNotify' : 'subscriptions.EditModal.successfullyChangedMessageNoNotify'
        }),
        type: 'success'
      });
    }
    close();
  };
  if (!subscription || !subscription.internalId) {
    return null;
  }
  return /*#__PURE__*/_jsx(SubscriptionsAdminHost, {
    isOpen: isOpen,
    initializeArgs: {
      subscriptionId: subscription.internalId
    },
    onClose: onClose
  });
}